import { useState } from 'react';
import { Box, Menu, MenuButton, MenuItem, MenuList, Grid, Divider, Flex } from '@chakra-ui/react';
import { generateRandomString } from '../../../global/helpers/global-helpers';
import { IoTextSharp, IoLogoYoutube, IoDocumentTextOutline } from 'react-icons/io5';
import { MdOutlineImage, MdOutlineVideocam, MdOutlineCallToAction } from 'react-icons/md';
import { PiMinus } from 'react-icons/pi';
import { FcGoogle } from "react-icons/fc";
import { CgSpaceBetweenV } from "react-icons/cg";
import { SiLoom } from 'react-icons/si';
import { FiUserCheck } from "react-icons/fi";
import { optionTypes } from "./types/subWidgetOptionsTypes";
import { BsSoundwave } from 'react-icons/bs';

export const AddSubWidget = ({ items, setItems, widget, dsrOwnerId }) => {
  const [isSubWidgetDropdownOpen, setIsSubWidgetDropdownOpen] = useState(false);

  const subWidgetDefaultOptions = (type) => {
    let option = {};

    switch (type) {
      case 'content-divider':
        option = { [optionTypes.STRENGTH]: 'medium' }
        break;

      case 'normal-text':
        option = { [optionTypes.ALIGN]: 'left' }
        break;

      case 'title-text':
        option = { [optionTypes.ALIGN]: 'left' }
        break;

      case 'user-signature':
        option = { [optionTypes.ALIGN]: 'left' }
        break;

      case 'content-spacer':
        option = { [optionTypes.HEIGHT]: '1em' }
        break;

      case 'cta-button':
        option = {
          [optionTypes.ALIGN]: 'center',
          [optionTypes.VARIANT]: 'primary'
        }
        break;

      default:
        option = {}
        break
    }

    return option;
  }

  const subWidgetDefaultContent = (type) => {
    let content = '';

    switch (type) {
      case 'content-divider':
        content = 'divider'
        break;

      case 'content-spacer':
        content = 'spacer'
        break;

      case 'user-signature':
        content = `${dsrOwnerId}`
        break;

      default:
        content = ''
        break
    }

    return content;
  }


  const addItem = (type) => {
    const columnId = Object.values(widget.widgetContent)[0].columnId

    let newSubWidget = {
      id: generateRandomString(10),
      contentBlockType: type || null,
      content: subWidgetDefaultContent(type),
      options: subWidgetDefaultOptions(type)
    }

    if (newSubWidget.contentBlockType !== null) {
      const objectWithNewItem = {
        ...items[widget.contentBlockId],
        widgetContent: {
          ...items[widget.contentBlockId].widgetContent,
          [columnId]: {
            ...items[widget.contentBlockId].widgetContent[columnId],
            subWidgets: {
              ...items[widget.contentBlockId].widgetContent[columnId].subWidgets,
              [newSubWidget.id]: newSubWidget
            }
          }
        }
      }

      setItems({
        ...items,
        [widget.contentBlockId]: objectWithNewItem
      });
    }
  };

  function ThisMenuLabel({ text }) {
    if (text) {
      return <Box mt='0.75em' px='1.5em' fontSize='0.75em' fontWeight='600' letterSpacing='1px' color='brandDark.500'>{text}</Box>
    } else return null

  }

  const standardItems = [
    {
      type: 'normal-text',
      text: 'Text block',
      subText: 'Formattable text content',
      icon: <IoTextSharp />
    },
    {
      type: 'cta-button',
      text: 'Button',
      subText: 'Adds a button that opens another tab',
      icon: <MdOutlineCallToAction />
    },
    // {
    //   type: 'title-text',
    //   text: 'Title text',
    //   subText: 'Pre-formatted section title to help with formatting',
    //   icon: <MdOutlineTextFields />
    // },
    // {
    //   type: 'uploaded-banner',
    //   text: 'Banner image',
    //   subText: 'Displays a full-width banner image',
    //   icon: <MdOutlineImage />
    // },
    // {
    //   type: 'url-image',
    //   text: 'Image by URL',
    //   subText: 'Add images by URL',
    //   icon: <MdOutlineImage />
    // },
  ];

  const stylingItems = [
    {
      type: 'content-divider',
      text: 'Divider',
      subText: 'A simple line to section your content',
      icon: <PiMinus />
    },
    {
      type: 'content-spacer',
      text: 'Spacer',
      subText: 'A negative space to help your content breathe',
      icon: <CgSpaceBetweenV />
    },
    {
      type: 'user-signature',
      text: 'Signature',
      subText: 'Add a dash of personal touch with your signature',
      icon: <FiUserCheck />
    }
  ]

  const mediaMenuItems = [
    {
      type: 'uploaded-image',
      text: 'Image',
      subText: 'Display images from your device',
      icon: <MdOutlineImage />
    },
    {
      type: 'uploaded-audio',
      text: 'Audio',
      subText: 'Record an audio file. Or upload one you already have.',
      icon: <BsSoundwave />
    },
    {
      type: 'uploaded-video',
      text: 'Upload Video',
      subText: 'Provide your own uploaded video',
      icon: <MdOutlineVideocam />
    },
    {
      type: 'uploaded-pdf',
      text: 'PDF',
      subText: 'Adds a scrollable PDF document',
      icon: <IoDocumentTextOutline />
    },
    {
      type: 'embed-document',
      text: 'Google document',
      subText: 'Provide a button link to your Google doc',
      icon: <FcGoogle />
    },
    {
      type: 'youtube-video',
      text: 'Embed YouTube',
      subText: 'Embed a Youtube video',
      icon: <IoLogoYoutube fill='red' />
    },
    {
      type: 'loom-video',
      text: 'Record live video',
      subText: 'Share your thoughts & screen with Loom',
      icon: <SiLoom fill='#8468fd' />
    },
  ];

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      mt='2em'
      mb='1em'
    >
      <Menu placement="auto" strategy="fixed" isOpen={isSubWidgetDropdownOpen} onClose={() => setIsSubWidgetDropdownOpen(false)}>
        <MenuButton
          borderWidth="1px"
          borderRadius="20px"
          h="40px"
          w="40px"
          color="white"
          bg='brand.500'
          fontSize="20px"
          pb="5px"
          onClick={() => { setIsSubWidgetDropdownOpen(!isSubWidgetDropdownOpen) }}
        >
          +
        </MenuButton>
        <MenuList zIndex='100' boxShadow={'lg'}>
          <ThisMenuLabel text="STANDARD" />
          <Grid templateColumns="repeat(2, 1fr)" margin="10px" minW={'780px'}>
            {standardItems.map((item) => {

              return (
                <AddSubWidgetMenuItem key={generateRandomString(5)} item={item} addItem={addItem} />
              )
            })}
          </Grid>

          <>
            <Divider mx="10px" borderBottomWidth="2px" />

            <ThisMenuLabel text="CONTENT & MEDIA" />
            <Grid templateColumns="repeat(2, 1fr)" margin="10px">
              {mediaMenuItems.map((item) => {
                return (
                  <AddSubWidgetMenuItem key={generateRandomString(5)} item={item} addItem={addItem} />
                )
              })}
            </Grid>
          </>


          <>
            <Divider mx="10px" borderBottomWidth="2px" />

            <ThisMenuLabel text="STYLING" />
            <Grid templateColumns="repeat(2, 1fr)" margin="10px">
              {stylingItems.map((item) => {
                return (
                  <AddSubWidgetMenuItem key={generateRandomString(5)} item={item} addItem={addItem} />
                )
              })}
            </Grid>
          </>
        </MenuList>
      </Menu>
    </Box>
  )
};

const AddSubWidgetMenuItem = ({ item, addItem }) => {
  return (
    <MenuItem onClick={() => addItem(item.type)} rounded='0.5em'>
      <Flex
        justifyContent="left"
        alignItems="center"
        width="100%"
        my="10px"
        rounded="10px"
      >
        <Flex
          justifyContent="center"
          alignItems="center"
          p="5px"
          marginRight="10px"
          borderRadius="lg"
          borderWidth="1px"
          width="40px"
          height="40px"
          bg="white"
        >
          {item.icon}
        </Flex>

        <Box>
          <Box fontSize='0.875em'>{item.text}</Box>
          {item.subText && <Box color='grey' fontSize='0.75em'>{item.subText}</Box>}
        </Box>
    </Flex>
    </MenuItem>
  )
}
